/*
 * Boppa · barra de envío gratis
 * El HTML se renderiza en el servidor con el total del carrito (carrito y cajón se
 * vuelven a pintar solos). Este script actualiza las barras que NO se repintan,
 * por ejemplo la de la página de producto, cada vez que se modifica el carrito.
 */
(function () {
  'use strict';

  var CART_URL_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function money(cents) {
    var pesos = Math.round(cents / 100);
    return '$' + pesos.toLocaleString('es-AR');
  }

  function paint(bar, total) {
    var threshold = Number(bar.getAttribute('data-threshold')) || 10000000;
    var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
    var reached = total >= threshold;
    var fill = bar.querySelector('.bp-fs__fill');
    var truck = bar.querySelector('.bp-fs__truck');
    var msg = bar.querySelector('[data-bp-fs-msg]');
    var track = bar.querySelector('.bp-fs__track');

    bar.setAttribute('data-total', String(total));
    bar.classList.toggle('is-reached', reached);
    if (fill) fill.style.width = pct + '%';
    if (truck) truck.style.left = pct + '%';
    if (track) track.setAttribute('aria-valuenow', String(Math.round(pct)));
    if (msg) {
      if (reached) msg.innerHTML = '¡Conseguiste el <strong>envío gratis</strong>!';
      else if (total === 0) msg.innerHTML = 'Envío gratis en compras desde <strong>' + money(threshold) + '</strong>';
      else msg.innerHTML = 'Te faltan <strong>' + money(threshold - total) + '</strong> para el envío gratis';
    }
  }

  function refresh() {
    var bars = document.querySelectorAll('[data-bp-fs]');
    if (!bars.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bars.forEach(function (bar) { paint(bar, cart.total_price); });
      })
      .catch(function () {});
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : input && input.url;
      var p = nativeFetch.apply(this, arguments);
      if (url && CART_URL_RE.test(url)) {
        p.then(function () { setTimeout(refresh, 250); }).catch(function () {});
      }
      return p;
    };
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
